import icon from "../../assets/downlink-speed.svg";
import type { Property } from "../../types";

export const downlinkSpeed: Property = {
  id: "downlinkSpeed",
  title: "downlinkSpeed.title",
  icon,
};
